<template>
	<MasonryContainer>
		<MasonryItem data-testid="settings-main-settings-card" headerKey="settings.vrsSettingsForm.settingsHeader">
			<SimpleSettingsForm :loading="isLoading" :settings="settings" :onUpdateField="onUpdateField" />
		</MasonryItem>
		<MasonryItem data-testid="settings-main-downloader-card" headerKey="settings.vrsSettingsForm.ftpDivider">
			<FTPSettingsForm ref="ftpSettingsForm" />
		</MasonryItem>
		<MasonryItem data-testid="settings-main-caster-vrs-card" headerKey="settings.vrsSettingsForm.casterVrsDivider">
			<DistancesSettingsForm :loading="isLoading" :settings="settings" />
		</MasonryItem>
		<MasonryItem data-testid="settings-main-ip-port-access-card" headerKey="settings.vrsSettingsForm.ipPortAccessHeader">
			<IpPortAccessForm
				:adminAccess="true"
				:loading="isLoading"
				:status="statusData"
				:secureData="secureData"
				:fetchSettings="fetchSettings" 
				@ftpoutPasswordUpdated="ftpoutPasswordUpdated"
			/>
		</MasonryItem>
		<MasonryItem data-testid="settings-main-cleaner-card" headerKey="settings.vrsSettingsForm.cleanerHeader">
			<CleanerSettingsForm :loading="isLoading" :settings="settings" />
		</MasonryItem>
		<MasonryItem data-testid="settings-main-trs-card" headerKey="settings.vrsSettingsForm.trsHeader">
			<TerrestrialReferenceSystemForm :loading="isLoading" :settings="settings" :trsOptions="statusData.trsOptions" />
		</MasonryItem>
		<MasonryItem v-if="licenseStore.allowPaas" data-testid="settings-main-paas-card" headerKey="settings.vrsSettingsForm.paasDivider">
			<PaasSettingsForm :loading="isLoading" :settings="settings" :onUpdateField="onUpdateField" />
		</MasonryItem>
		<MasonryItem data-testid="settings-main-time-sync-card" headerKey="settings.vrsSettingsForm.otherSettingsDivider">
			<OtherSettingsForm :loading="isLoading" :settings="settings" />
		</MasonryItem>
		<MasonryItem data-testid="settings-main-leap-seconds-card" headerKey="settings.vrsSettingsForm.lsFileDivider">
			<LeapSecondsForm />
		</MasonryItem>
		<MasonryItem data-testid="settings-main-actions-card" headerKey="settings.actionsHeader">
			<ContainerRestartForm />
		</MasonryItem>
	</MasonryContainer>
</template>

<script>
import { ref, onMounted } from 'vue';

import Api from '@/api/Api';
import { toCamelCase } from '@/api/ApiHelpers';

import { showErrorMessage } from '@/components/common/errorMessage';

import ApiOps from '@/api/ApiOps';

import SimpleSettingsForm from '@/components/settings/SimpleSettingsForm.vue';
import FTPSettingsForm from '@/components/settings/FTPSettingsForm.vue';
import DistancesSettingsForm from '@/components/settings/DistancesSettingsForm.vue';
import IpPortAccessForm from '@/components/settings/IpPortAccessForm.vue';
import CleanerSettingsForm from '@/components/settings/CleanerSettingsForm.vue';
import OtherSettingsForm from '@/components/settings/OtherSettingsForm.vue';
import PaasSettingsForm from '@/components/settings/PaasSettingsForm.vue';
import LeapSecondsForm from '@/components/settings/LeapSecondsForm.vue';

import ContainerRestartForm from '@/components/settings/ContainerRestartForm.vue';
import TerrestrialReferenceSystemForm from '@/components/settings/TerrestrialReferenceSystemForm.vue';
import MasonryContainer from '@/components/masonry/MasonryContainer.vue';
import MasonryItem from '@/components/masonry/MasonryItem.vue';

import { useLicenseStore } from '@/stores/licenseStore';

export default {
	components: {
		MasonryContainer, MasonryItem,
		SimpleSettingsForm, FTPSettingsForm, DistancesSettingsForm, IpPortAccessForm, CleanerSettingsForm,
		OtherSettingsForm, ContainerRestartForm, PaasSettingsForm, LeapSecondsForm,
		TerrestrialReferenceSystemForm,
	},
	setup() {
		const isLoading = ref(true);
		const settings = ref({});
		const statusData = ref({});
		const secureData = ref({});
		const licenseStore = useLicenseStore();
		const fetchSettings = (callback, hideLoading) => {
			if (!hideLoading) {
				isLoading.value = true;
			}
			Api.vrsSettingsGet(responseData => {
				settings.value = toCamelCase(responseData.settings);
				statusData.value = responseData.statusData;
				secureData.value = responseData.secureData;
				isLoading.value = false;
				if (callback) {
					callback(responseData);
				}
			});
		};
		onMounted(fetchSettings);
		const handleSettingsUpdateField = response => {
			if (response.status !== 'ok') {
				showErrorMessage(response.errors);
				fetchSettings();
				return;
			}
			ApiOps.profileGetDetails();
		};
		const onUpdateField = (field, value, handler) => {
			Api.vrsSettingsFieldPost(field, value, handler || handleSettingsUpdateField);
		};
		const ftpoutPasswordUpdated = newPassword => {
			secureData.value = {
				...secureData.value,
				ftpoutPassword: newPassword,
			}
		}
		const ftpSettingsForm = ref();
		const onLicenseUpdate = () => {
			ftpSettingsForm.value.fetchSettings();
			fetchSettings();
		};
		return {
			isLoading,
			settings,
			statusData,
			secureData,
			fetchSettings,
			onUpdateField,
			ftpoutPasswordUpdated,
			licenseStore,
			ftpSettingsForm,
			onLicenseUpdate,
		};
	},
}
</script>
